import React, { useState } from 'react';
import { ChevronLeft, ChevronRight, Star } from 'lucide-react';
import './Testimonials.css';

const testimonials = [
  {
    name: 'Ananya Krishnan',
    image: 'https://images.unsplash.com/photo-1484863137850-59afcfe05386?crop=entropy&cs=srgb&fm=jpg&q=85',
    text: 'I put off implants for years because I dreaded the process. The team explained every step, the procedure was far more comfortable than I imagined, and the results look completely natural. I only wish I had come in sooner.',
    treatment: 'Dental implants'
  },
  {
    name: 'Rahul Mehta',
    image: 'https://images.unsplash.com/photo-1517677129300-07b130802f46?crop=entropy&cs=srgb&fm=jpg&q=85',
    text: 'I needed urgent care for a painful tooth and they fit me in quickly. No upselling, just clear options and honest pricing. The dentist was calm and thorough—I finally have a practice I actually trust.',
    treatment: 'Emergency & restorative care'
  },
  {
    name: 'Priya Sharma',
    image: 'https://images.pexels.com/photos/774909/pexels-photo-774909.jpeg',
    text: 'I came in for a smile refresh and the attention to shape, shade, and bite detail blew me away. The studio feels premium without being cold, and the staff remember you by name. Could not be happier with my new smile.',
    treatment: 'Cosmetic dentistry'
  },
  {
    name: 'Vikram Iyer',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop',
    text: 'As someone who gets anxious in the chair, I appreciate how unhurried everything feels—noise-canceling calm, gentle technique, and they check in the whole time. My deep cleaning was the easiest I have ever had.',
    treatment: 'Hygiene & preventive care'
  }
];

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextTestimonial = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section id="testimonials" className="testimonials-section section-padding">
      <div className="container">
        <div className="testimonials-header fade-in">
          <h2 className="heading-1">What Our Patients Say</h2>
          <div className="section-divider"></div>
          <p className="body-large testimonials-subtitle">
            Real experiences from our valued patients
          </p>
        </div>

        <div className="testimonials-slider">
          <button className="slider-btn slider-btn-prev" onClick={prevTestimonial}>
            <ChevronLeft size={24} />
          </button>

          <div className="testimonial-card fade-in">
            <div className="testimonial-stars">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={20} fill="var(--gold-primary)" color="var(--gold-primary)" />
              ))}
            </div>
            <p className="body-large testimonial-text">"{testimonials[currentIndex].text}"</p>
            <div className="testimonial-author">
              <img 
                src={testimonials[currentIndex].image} 
                alt={testimonials[currentIndex].name} 
                className="testimonial-image"
              />
              <div className="testimonial-info">
                <h4 className="heading-3">{testimonials[currentIndex].name}</h4>
                <p className="body-small">{testimonials[currentIndex].treatment}</p>
              </div>
            </div>
          </div>

          <button className="slider-btn slider-btn-next" onClick={nextTestimonial}>
            <ChevronRight size={24} />
          </button>
        </div>

        <div className="testimonial-dots">
          {testimonials.map((_, index) => (
            <button
              key={index}
              className={`dot ${index === currentIndex ? 'dot-active' : ''}`}
              onClick={() => setCurrentIndex(index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;